module.exports = __webpack_public_path__ + "img/empty-comments.762fea5e.svg";